import { create } from "zustand";
import type { DevTicket, DevTicketStatus } from "types/dev_ticket";
import { devTicketsApi } from "@services/api/devTickets";

interface TicketStore {
  tickets: DevTicket[];
  isLoading: boolean;
  fetchTickets: () => Promise<void>;
  updateTicketStatus: (ticketId: string, status: DevTicketStatus) => Promise<void>;
  deleteTicket: (ticketId: string) => Promise<void>;
}

export const useTicketStore = create<TicketStore>((set, get) => ({
  tickets: [],
  isLoading: false,

  fetchTickets: async () => {
    set({ isLoading: true });
    try {
      const tickets = await devTicketsApi.list();
      set({ tickets, isLoading: false });
    } catch (error: any) {
      console.error("❌ Error fetching dev tickets:", error);
      set({ isLoading: false });
    }
  },

  updateTicketStatus: async (ticketId: string, status: DevTicketStatus) => {
    // Optimistic update
    const prev = get().tickets;
    set({
      tickets: prev.map((t) =>
        t.id === ticketId ? { ...t, status } : t
      ),
    });
    try {
      await devTicketsApi.updateStatus(ticketId, status);
    } catch (error: any) {
      console.error("❌ Error updating ticket status:", error);
      set({ tickets: prev }); // Revert
    }
  },

  deleteTicket: async (ticketId: string) => {
    const prev = get().tickets;
    set({ tickets: prev.filter((t) => t.id !== ticketId) });
    try {
      await devTicketsApi.delete(ticketId);
    } catch (error: any) {
      console.error("❌ Error deleting ticket:", error);
      set({ tickets: prev }); // Revert
    }
  },
}));
